import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  appConfig,
  Firebase,
  isDevelopment,
  verifyWhitelistedEmailDomain,
  focusAfterTimeout,
} from './../../util';

class AssessmentPasswordlessAuth extends Component {

  state = {
    email: '',
    password: '',
    loginError: null,
    loginMessage: null,
    syncingWithServer: false,
    emailVerificationSent: false,
    passwordLoginActive: false,
  }

  handleSubmit(event){
    event.preventDefault();
  }

  getContinueButtonHtml(){
    return {
      __html: (this.state.syncingWithServer ? 'Verifying...' : 'Continue')
    };
  }

  loginWithEmailAndPassword(){
    const {
      email,
      password
    } = this.state;

    this.setState({
      syncingWithServer: true,
      loginError: false
    });

    Firebase.auth().signInWithEmailAndPassword(email, password).catch(error => {
      console.log('loging error: ', error);
      this.setState({
        syncingWithServer: false,
        loginError: error.message,
      });
    }).then(() => {
      console.log('firebase signin THEN!');
      // this.setState({
      //   redirectToReferrer: true,
      // });
    });
  }

  submitEmail(){

    const {email} = this.state;

    this.setState({
      syncingWithServer: true,
      loginError: false
    });

    Firebase.auth().fetchSignInMethodsForEmail(email).then(signInMethods => {
      if(signInMethods && signInMethods.indexOf('password') !== -1){
        //has password authentication, use this instead
        this.setState({
          syncingWithServer: false,
          passwordLoginActive: true,
        });

        focusAfterTimeout(this, 'passwordInput');
      }
      else{

        const actionCodeSettings = {
          // URL you want to redirect back to. The domain (www.example.com) for this
          // URL must be whitelisted in the Firebase Console.
          url: `${document.location.href}`,
          // This must be true.
          handleCodeInApp: true,
        }

        if(this.props.assessmentConfig.whitelistedEmailDomains && !verifyWhitelistedEmailDomain(email, this.props.assessmentConfig.whitelistedEmailDomains)){
          this.setState({
            loginError: `Invalid email address. Please use the email address provided to you by ${this.props.orgConfig.name}.`,
            syncingWithServer: false,
          });

          return;
        }

        Firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings).then(() => {
          window.localStorage.setItem('velocity_email_for_signin_link', email);
          this.setState({
            syncingWithServer: false,
            emailVerificationSent: true,
            loginMessage: `Sign-in link sent to ${email}. Please check your email to continue (including spam folder)...`
          });
        }).catch(err => {
          console.error(err);
          this.setState({
            loginError: err.message
          });
        });
      }
    }).catch(err => {
      this.setState({
        syncingWithServer: false,
        loginError: 'Invalid email, please check input and try again.'
      })
    });
  }

  renderPasswordlessSignin(){

    const {
      email,
      password,
      syncingWithServer,
      loginError,
      loginMessage,
      emailVerificationSent,
      passwordLoginActive,
    } = this.state;

    const { assessmentConfig } = this.props;

    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <div className="velocity-form page-form">
          <h2>Assessment Login</h2>
          {isDevelopment() && false &&
            <template style={{marginBottom: '20px'}}>
              <h6 style={{color: '#545B72', marginTop: '0px', marginBottom:'5px'}}>QUICK LOGIN (DEVELOPMENT ONLY)</h6>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('new'); }} className="button grey-outline button-micro">New Assessment</button>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('inprogress'); }} className="button grey-outline button-micro">In Progress Assessment</button>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('completed'); }} className="button grey-outline button-micro">Completed Assessment</button>
            </template>
          }
          {loginError &&
            <div className="form-message error">{loginError}</div>
          }
          {loginMessage &&
            <div className="form-message success">{loginMessage}</div>
          }
          <div className="form-group">
            <label htmlFor="velocity-login-email">Email</label>
            <input ref={input => { this.emailInput = input; }} id="velocity-login-email" disabled={syncingWithServer || emailVerificationSent} type="text" placeholder="Email" value={email} onChange={(e) => this.setState({ email: e.target.value }) } />
          </div>
          {passwordLoginActive &&
            <div className="form-group">
              <label htmlFor="velocity-login-password">Password</label>
              <input ref={input => { this.passwordInput = input; }} id="velocity-login-password" disabled={syncingWithServer} type="password" placeholder="Password" value={password} onChange={(e) => this.setState({ password: e.target.value }) } />
            </div>
          }
          {!emailVerificationSent && !passwordLoginActive &&
            <div className="form-group">
              <button className={'button primary' + (syncingWithServer ? ' disabled' : '')} disabled={syncingWithServer} onClick={this.submitEmail.bind(this)} dangerouslySetInnerHTML={this.getContinueButtonHtml()}></button>
            </div>
          }
          {passwordLoginActive &&
            <div className="form-group">
              <button className={'button primary' + (syncingWithServer ? ' disabled' : '')} disabled={syncingWithServer} onClick={this.loginWithEmailAndPassword.bind(this)}>{syncingWithServer ? 'Logging in...' : 'Login'}</button>
            </div>
          }
        </div>
      </form>
    )
  }

  render(){

    // const orgLookup = document.location.pathname.split('/')[2];
    // const orgLookupPresentInUrl = orgLookup && orgLookup !== '';

    return (
      <div className="page login">
        {this.renderPasswordlessSignin()}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    orgConfig: state.orgConfig.data,
  }
}

export default connect(mapStateToProps, {})(AssessmentPasswordlessAuth);



// WEBPACK FOOTER //
// ./src/components/takeAssessment/assessmentPasswordlessAuth.js